import { render, staticRenderFns } from "./BaseType.vue?vue&type=template&id=004e82ac&"
import script from "./BaseType.vue?vue&type=script&lang=js&"
export * from "./BaseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports